import isEqual from 'lodash/isEqual';
import { useEffect, useState } from 'react';

const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};

export function useDebounceWithDeepCompare<T>(value: T, delay = 300): T {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (!isEqual(value, debouncedValue)) {
                setDebouncedValue(value);
            }
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay, debouncedValue]);

    return debouncedValue;
}

export default useDebounce;
